/**
 * Empirycznie z wolesushi.pl: Sonnet 4.6 × 14 seedów = $1.08 → $0.077/seed.
 * Waha się ±30% zależnie od liczby nodów w seedzie (prompt size).
 * Service używane w UI buttonie "Pełny audyt + LLM Sonnet" do dynamic cost label.
 */

export function estimateLlmAuditCost(seedCount: number): number {
  if (seedCount <= 0) return 0;
  return Math.round(seedCount * 0.077 * 100) / 100;
}

export function estimateLlmAuditDuration(seedCount: number): number {
  if (seedCount <= 0) return 0;
  return Math.ceil(seedCount * 2.1); // ~2s/seed Sonnet 4.6
}

export function formatAuditCost(seedCount: number): string {
  const cost = estimateLlmAuditCost(seedCount);
  const duration = estimateLlmAuditDuration(seedCount);
  return `~$${cost.toFixed(2)}/mapa · ~${duration}s`;
}
